export default __webpack_public_path__ + "static/media/Neophyte's Belt of the Emissary.a307408e.jpg";